export default __webpack_public_path__ + "static/media/our-story.63793ed0.png";